export const OT_PROTOCOL_ITEMS = [
    // 0: Job Header
    {
        id: 0,
        type: 'header',
        title: "Job Descriptions",
        position: "Occupational Therapist",
        reportsTo: "Clinical Supervisor"
    },
    // 1: Job Description Summary
    {
        id: 1,
        type: 'text_block',
        title: "JOB DESCRIPTION SUMMARY:",
        text: "The occupational therapist is responsible for the assessment and treatment of patients who require occupational therapy services. The occupational therapist provides these services in the patient's home under the direction of the physician and in accordance with the physician's plan of care."
    },
    // 2: Essential Job Functions/Responsibilities
    {
        id: 2,
        type: 'section',
        title: "ESSENTIAL JOB FUNCTIONS/RESPONSIBILITIES:",
        duties: [
            "Assesses patient's occupational therapy needs and develops a plan of care for occupational therapy in coordination with the physician and other Organization personnel.",
            "Initializes the plan of care.",
            "Provides direct occupational therapy according to the physician's plan of care.",
            "Treats patient to relieve pain, develop or restore function, and maintain maximum performance using physical means, such as therapeutic exercise, massage, heat, water, light, and electricity.",
            "Directs and aids patients in active and passive therapeutic exercises, muscle reeducation, gait and functional training, transfer activities and prosthetic training.",
            "Instructs patients in care and use of wheelchairs, braces, crutches, canes, and prosthetic or orthotic devices.",
            "Regularly re-evaluates the patient's occupational therapy needs.",
            "Observes and reports to the physician and Organization personnel the patient's reaction to treatment and any changes in patient's condition.",
            "Counsels the patient and family in meeting occupational therapy and related needs.",
            "Assists in coordinating all services provided.",
            "Educates and instructs the patient, family, or staff as required.",
            "Identifies problems for which occupational therapy services are to be provided and selects those that can be addressed within the scope of services offered by the Organization.",
            "Begins planning for discharge when treatment goals are being attained or when no longer attainable.",
            "Coordinates patient care and discharge planning with the physician and other members of the health care team.",
            "Collects and completes the Outcome and Assessment Information Set (OASIS) developed and mandated by CMS. Submits data sets within the guidelines established by CMS.",
            "Maintains necessary records; clinical notes and conference notes, which will be incorporated into the patient's clinical record in prescribed time frames.",
            "Participates in Organization Home Care Team Member meetings and Organization Inservice Education Program.",
            "Supervises the occupational therapy assistant every 30 days in the home or as required. Supervises the home health aide every 14 days when occupational therapy is the only skilled service being provided.",
            "Performs other duties as assigned."
        ]
    },
    // 3: Position Qualifications
    {
        id: 3,
        type: 'section',
        title: "POSITION QUALIFICATIONS:",
        list: [
            "Graduate of an accredited occupational therapy program with either a Bachelor's, Master's or Doctorate degree in occupational therapy.",
            "Current certification or license as required by state law.",
            "Three years of experience as a professional occupational therapist is preferred.",
            "Possesses and maintains current CPR certification.",
            "Must be a licensed driver with an automobile that is insured in accordance with state or organization requirements and is in good working order."
        ]
    },
    // 4: Signature Block
    {
        id: 4,
        type: 'signature',
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "signatureDate", inputType: "date" }
        ]
    },
    // 5: Footer
    {
        id: 5,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];
